'use client';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PublishedWithChangesRoundedIcon from '@mui/icons-material/PublishedWithChangesRounded';
import useKeypress from '@wt/shared/hooks/useKeyPress';
import { useEffect, useRef } from 'react';

const PlayAgainModal = ({
  closeModal,
  handleClickSeeResults,
  handleClickPlayAgain,
}: {
  closeModal: () => void;
  handleClickSeeResults: () => void;
  handleClickPlayAgain: () => void;
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useKeypress('Escape', () => {
    closeModal();
  });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !event.composedPath().includes(modalRef.current)
      ) {
        closeModal();
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [modalRef]);

  return (
    <div className="modal pointer-events-auto visible flex items-center justify-center opacity-100">
      <div
        ref={modalRef}
        className="modal-box visible fixed z-50 w-full max-w-md bg-white"
      >
        <div className="flex flex-col gap-4">
          <div className="flex w-full flex-row items-center justify-between">
            <div className="flex flex-row items-center">
              <div className="mr-3 flex size-7 items-center justify-center rounded-full bg-[#FFF6E5] md:size-11">
                <PublishedWithChangesRoundedIcon
                  htmlColor="#FFA800"
                  className="text-lg md:text-3xl"
                />
              </div>
              <div className="text-base text-[#322E38] md:text-2xl">
                Play again?
              </div>
            </div>
            <div className="cursor-pointer" onClick={closeModal}>
              <CloseRoundedIcon
                htmlColor="#4B4554"
                className="text-lg md:text-3xl"
              />
            </div>
          </div>
          <span className="text-sm text-[#1A0F2A] md:text-base">
            You’ve already played this game. Do you want to play it again or
            just look at the results from last time?
          </span>
          <span className="text-sm text-[#1A0F2A] md:text-base">
            If you choose to play the game again your old results will be
            overwritten.
          </span>
          <div className="flex w-full flex-row justify-center gap-6">
            <button
              type="button"
              onClick={handleClickSeeResults}
              className="btn h-[33px] min-h-[33px] shrink border border-[#645C70] bg-white px-5 text-sm font-normal text-[#230351] hover:bg-[#F6F0FE] md:h-[40px] md:min-h-[40px] md:px-8 md:text-base"
            >
              See results
            </button>
            <button
              type="button"
              onClick={handleClickPlayAgain}
              className="btn btn-primary h-[33px] min-h-[33px] shrink px-5 text-sm font-normal text-white md:h-[40px] md:min-h-[40px] md:px-8 md:text-base"
            >
              Play again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayAgainModal;
